class bodyOverlay {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._evt = new CustomEvent('overlay-hit')
    }

    onInit () {
        // this.detectHit()
        // this._elem.addEventListener('overlay-hit', e => {
        //   if (!this._elem.overlayStatus) return false
        //   this._elem.classList.remove('overlay')
        //   this._elem.overlayStatus = false
        // })
    }

    detectHit () {
        this._elem.addEventListener('click', e => {
            let overlayStatus = this._elem.overlayStatus
            if (!overlayStatus) return false
            let hitElem = false
            let elemToCheck = e.target
            this._elemsToIgnore = this._elem.querySelectorAll('[data-body-overlay-ignore], .body-overlay__ignore')
            while (!hitElem) {
                if (elemToCheck.nodeName.toLowerCase() === 'html') {
                    hitElem = true
                    document.body.dispatchEvent(this._evt)
                }
                for (let elem of this._elemsToIgnore) {
                    if (elem === elemToCheck) {
                        hitElem = true
                    }
                }
                elemToCheck = elemToCheck.parentElement
            }
        })
    }
}

export default bodyOverlay



// WEBPACK FOOTER //
// ./src/scripts/components/BodyOverlay.js